<template>
  <v-card>
    <v-toolbar color="primary" class="rounded-0 text-white" height="80px">
      <v-toolbar-title class="ml-3">
        <h2><b>Tanımlar</b> - Eğitim Listesi</h2>
      </v-toolbar-title>
      <v-spacer />
      <div class="d-flex align-items-center">
        <v-icon
          color="error cursor-pointer"
          class="mr-2"
          dark
          v-permission="{
            permissions: ['educations-delete'],
          }"
          :disabled="!isSelectable"
          @click="showDeleteTrainingModal"
        >
          mdi-delete
        </v-icon>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              color="cursor-pointer"
              @click="() => fetchTrainings()"
              v-bind="attrs"
              dark
              v-on="on"
            >
              mdi-reload
            </v-icon>
          </template>
          <span>Yenile</span>
        </v-tooltip>
        <v-text-field
          v-model="search"
          label="Ara"
          class="mx-4 mt-0 pt-0"
          hide-details="auto"
          dark
          single-line
          append-icon="search"
        ></v-text-field>
        <router-link
          :to="{ name: 'def-trainings-edit', query: { editable: true } }"
        >
          <v-btn
            elevation="0"
            v-permission="{
              permissions: ['educations-create'],
            }"
            color="success"
          >
            <v-icon small>mdi-plus</v-icon>
            Yeni Eğitim
          </v-btn>
        </router-link>
      </div>
      <KTTopMenu></KTTopMenu>
    </v-toolbar>
    <v-card-text>
      <v-data-table
        v-model="selectedTraining"
        :headers="headers"
        :items="trainings"
        :search="search"
        :single-select="true"
        sort-by="id"
        :loading="loading"
        sort-desc="true"
        :items-per-page="100"
        show-select
        item-key="id"
      >
        <template #item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <router-link
                :to="{
                  name: 'def-trainings-edit',
                  params: { id: item.id },
                  query: { editable: true },
                }"
              >
                <v-icon
                  color="warning"
                  small
                  v-permission="{
                    permissions: ['educations-update'],
                  }"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-pencil
                </v-icon>
              </router-link>
            </template>
            <span>Düzenle</span>
          </v-tooltip>
        </template>
        <template #item.name="{ item }">
          <router-link
            v-permission="{
              permissions: ['educations-read'],
            }"
            :to="{
              name: 'def-trainings-edit',
              params: { id: item.id },
              query: { editable: false },
            }"
          >
            {{ item.name }}
          </router-link>
        </template>

        <template #item.price="{ item }">
          {{ formatPrice(item.price) }}
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import KTTopMenu from "@/view/layout/header/TopMenu.vue";
import {
  FETCH_TRAININGS,
  DELETE_TRAINING,
} from "@/core/services/store/definitions/trainings.module";
import { formatPrice } from "@/core/helper.js";

export default {
  name: "LeadList",
  components: {
    KTTopMenu,
  },
  data() {
    return {
      search: "",
      headers: [
        { text: "Eğitim İsmi", value: "name", align: "left" },
        { text: "Baz Fiyat", value: "price", align: "left" },
        {
          text: "",
          value: "actions",
          align: "left",
          sortable: false,
        },
        { text: "", value: "data-table-select", align: "right" },
      ],
      selectedTraining: [],
      loading: true,
    };
  },
  mounted() {
    this.fetchTrainings().then(() => (this.loading = false));
  },
  methods: {
    ...mapActions([FETCH_TRAININGS, DELETE_TRAINING]),
    formatPrice,
    async acceptDelete() {
      try {
        this.deleteTraining(this.selectedTraining[0]);
        this.$toast.success("Eğitim silindi", {
          position: "bottom-right",
          duration: 2000,
        });
        this.selectedTraining = [];
      } catch (error) {
        this.$toast.error(error[0].detail, {
          position: "bottom-right",
          duration: 2000,
        });
      }
    },
    showDeleteTrainingModal() {
      const params = {
        title: "Seçtiğiniz eğitim silinecek",
        text: "Seçili eğitimi silmek istediğinize emin misiniz?",
        onConfirm: () => {
          return this.acceptDelete();
        },
      };
      this.$approvalModal.show(params);
    },
  },
  computed: {
    ...mapGetters(["trainings"]),
    isSelectable() {
      return this.selectedTraining.length === 1;
    },
  },
};
</script>
